import { render, staticRenderFns } from "./TepTurnoCancelacion.vue?vue&type=template&id=dbd4566a"
import script from "./TepTurnoCancelacion.vue?vue&type=script&lang=js"
export * from "./TepTurnoCancelacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports